import React from 'react'
import './footer.scss'

import logo from './sunrise-logo.png'

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>
          klick:sieger® - Online-Marketing Software © Sunrise Web &amp; Marketing GmbH
          <br />
          www.sunrise-web.de · Ziegelhäuser Landstr. 63 · 69120 Heidelberg · Germany ·
          klicksieger@sunrise-web.de
          <a href="https://www.sunrise-web.de/">
            <img src={logo} alt="Sunrise Web &amp; Marketing" />
          </a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
